/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum IntegrationCheckOwner {
  FreightSimple = "FreightSimple",
  PartnerDashboard = "PartnerDashboard",
  Merchant = "Merchant",
}

export function instanceOfIntegrationCheckOwner(value: any): boolean {
  for (const key in IntegrationCheckOwner) {
    if (Object.prototype.hasOwnProperty.call(IntegrationCheckOwner, key)) {
      if (
        IntegrationCheckOwner[key as keyof typeof IntegrationCheckOwner] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function IntegrationCheckOwnerFromJSON(
  json: any,
): IntegrationCheckOwner {
  return IntegrationCheckOwnerFromJSONTyped(json, false);
}

export function IntegrationCheckOwnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationCheckOwner {
  return json as IntegrationCheckOwner;
}

export function IntegrationCheckOwnerToJSON(
  value?: IntegrationCheckOwner | null,
): any {
  return value as any;
}

export function IntegrationCheckOwnerToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): IntegrationCheckOwner {
  return value as IntegrationCheckOwner;
}
